import React from 'react';
import { Step } from './components';
import { ProgressStepsContainer } from './ProgressSteps.styles';
import { IStep } from '../../NewMandateForm';

export interface Props {
  activeStep: number;
  steps: IStep[];
}

const ProgressSteps = ({ activeStep = 0, steps, ...rest }: Props) => {
  const progress = (activeStep / steps.length) * 100;

  return (
    <ProgressStepsContainer
      {...rest}
      role="progressbar"
      aria-valuenow={progress}
    >
      {steps.map((step, i) => (
        <Step
          activeStep={i}
          beforeActive={i <= activeStep}
          afterActive={i < activeStep}
          key={step.name}
        >
          {step.name}
        </Step>
      ))}
    </ProgressStepsContainer>
  );
};

export default ProgressSteps;
